import React, { useState, useEffect }  from "react";
import { useLocation } from 'react-router-dom';
import CartInputField from '../Components/Cart/CartInputField';
import isEmail from 'validator/lib/isEmail';
import OkPopup from "../Components/OkPopup";
import ReCAPTCHA from "react-google-recaptcha";
import ContactsSnippet from "../Components/RichSnippet/ContactsSnippet";

const ContactPage = (props) => {
  const location = useLocation();
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [showDialog, setShowDialog] = useState(false)

  const [FormName, setFormName] = useState("");
  const [FormLastname, setFormLastname] = useState("");
  const [FormEmail, setFormEmail] = useState("");
  const [FormObject, setFormObject] = useState("");
  const [FormContent, setFormContent] = useState("");
  const [FormCaptcha, setFormCaptcha] = useState("");
  const [ErrorList, setErrorList] = useState([]);
  const [Message, setMessage] = useState("");
  const [OutcomeMessage, setOutcomeMessage] = useState("");
  //const recaptchaRef = React.createRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  useEffect(() => {
    setMessage("");    
  }, [FormName, FormLastname, FormEmail, FormObject, FormContent]);

  function checkTextValue(txt, fieldName, special = "") {
    if (txt.trim().length === 0)
      //return fieldName + " deve avere valore valido";
      return "Si prega di non lasciare il campo vuoto.";
    if (special === "email") {
      // controllo aggiuntivo: verifichiamo che il valore in FormEmail sia uguale all'ultimo validato con successo
      if (!isEmail(txt))
          return "Inserire un indirizo di email valido.";
    }

    return "";
  }

  const sendFormHandler = () => {
    var errList = [];
    let res = "";

    //const recaptchaValue = recaptchaRef.current.getValue();
    //console.log("recaptchaValue = " + recaptchaValue);
    console.log("recaptchaValue = " + FormCaptcha);
    
    res = checkTextValue(FormEmail, "Indirizzo Email", "email");
    if (res !== "") errList.push({ id: "Email", msg: res }); 
    res = checkTextValue(FormName, "Nome");
    if (res !== "") errList.push({ id: "Name", msg: res });
    res = checkTextValue(FormLastname, "Cognome");
    if (res !== "") errList.push({ id: "LastName", msg: res });
    res = checkTextValue(FormObject, "Oggetto");
    if (res !== "") errList.push({ id: "Object", msg: res });
    res = checkTextValue(FormContent, "Contenuto");
    if (res !== "") errList.push({ id: "Msg", msg: res });
    res = checkTextValue(FormCaptcha, "Captcha");
    if (res !== "") {
      errList.push({ id: "Captcha", msg: res });
    }

    setErrorList(errList);
    //console.log(errList);
  
    if (errList.length > 0) {
      setMessage("La compilazione dei dati è errata. Segui le indicazioni e riprova!");
      return;
    } else {
      setMessage("");
    }

    let params = [
      { name: "nome", value: FormName },
      { name: "cognome", value: FormLastname },
      { name: "oggetto", value: FormObject },
      { name: "messaggio", value: FormContent },
      { name: "email", value: FormEmail },
      { name: "captcha", value: FormCaptcha },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/utility/ContactForm",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (result) => {
        //console.log(result);
        if (result.status === "true") {
          //setOutcomeMessage("Operazione completata con successo. " + result.message);
          setOutcomeMessage(result.message);
          setFormName("");
          setFormLastname("");
          setFormObject("");
          setFormContent("");
          setFormEmail("");
          setFormCaptcha("");
          //setMessage("Messaggio inviato.");
        } else {
          setOutcomeMessage(result.message);
        }
        setShowDialog(true);
        //console.log(result);
      }
    );    
  };

  const closeDialog = () => {
    setShowDialog(false);
  }

  const onRecaptchaChange = (value) => {
    //console.log("Captcha value = " + value);
    setFormCaptcha(value);
  }

  function showError(inputName) {
    if (ErrorList.length === 0)
      return null;
    let errList = ErrorList.filter((el) => el.id === inputName);
    if (errList.length > 0) {
      return (
        <div className="errore_cart">
          {errList.map((el, i) => (
            <p key={"er_"+i}>{el.msg}</p>
          ))}
        </div>
      )
    }
  } 

  const startingStyle = {
    border: "1px solid #B3B3B3",
  };
  const validStyle = {
    border: "1px solid green",
  };
  const invalidStyle = {
    border: "1px solid red",
  };
  function setMsgStyle(required) {
    let err = ErrorList.filter((el) => el.id === "Msg");     
    if (!required) return startingStyle;
    if (FormContent.length === 0 && (!err || err.length === 0)) return startingStyle;
    if (FormContent.length > 0 && (!err || err.length === 0)) return validStyle;
    else return invalidStyle;
  }

  return (
    <>
      <div className="contenitore_01">
        <div className="contenuto_contatti">
          <h1 className="titolo_pagina">Contattaci!</h1>

          <div className="area_mappa">
            <iframe
              title="dove siamo"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4786.156427042559!2d11.344639711427108!3d44.497419854028074!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7e37f89d78f642e6!2sPesaro%20Giocattoli%20di%20Mediatoys%20Srl%20Bologna!5e0!3m2!1sit!2sit!4v1629712487971!5m2!1sit!2sit"
              width="100%"
              height="450"
              allowFullScreen=""
              style={{ border: "0" }}
              loading="lazy"
            />
          </div>

          <div className="area_form">
            {showDialog ? (
              <OkPopup
                titletext="Operazione completata"
                text={OutcomeMessage}
                closeHandler={closeDialog}
              />
            ) : null}
            <h2>{props.cfg.name}</h2>
            <p>{props.cfg.address}</p>
            <p>
            {props.cfg.city}
            &nbsp;
            {props.cfg.country}
            </p>
            <p>Servizio Clienti: {props.cfg.phone}</p>
            <p>Responsabile Vendite: {props.cfg.mobile} {props.cfg.mobileText}</p>
            <p>&nbsp;</p>
            <p>
              Per contattarci, compila i campi sottostanti. Quelli
              contrassegnati con '*' sono obbligatori.
            </p>
            <p>&nbsp;</p>
            <form autoComplete="off">
              <input type="hidden" autoComplete="off" />
              <CartInputField
                required={true}
                type="text"
                lbl="Indirizzo E-mail"
                name="Email"
                value={FormEmail}
                change={setFormEmail}
                cssClass="riga_info_cart"
                errList={ErrorList}
              />
              <CartInputField
                required={true}
                type="text"
                lbl="Nome"
                name="Name"
                value={FormName}
                change={setFormName}
                cssClass="riga_info_cart"
                errList={ErrorList}
              />
              <CartInputField
                required={true}
                type="text"
                lbl="Cognome"
                name="LastName"
                value={FormLastname}
                change={setFormLastname}
                cssClass="riga_info_cart"
                errList={ErrorList}
              />
              <CartInputField
                required={true}
                type="text"
                lbl="Oggetto"
                name="Object"
                value={FormObject}
                change={setFormObject}
                cssClass="riga_info_cart"
                errList={ErrorList}
              />
              <div className="riga_note_cart">
                <label>Contenuto *</label>
                <textarea
                  className="note_cart"
                  onChange={(e) => setFormContent(e.target.value)}
                  name="Msg"
                  value={FormContent}
                  style={setMsgStyle(true)}
                />
                {showError("Msg")}
              </div>

              <div className="riga_recaptcha">
                <ReCAPTCHA
                  //ref={recaptchaRef}
                  sitekey={props.cfg.reCaptchaKey}
                  onChange={onRecaptchaChange}
                />
                {showError("Captcha")}
              </div>
            </form>
            {Message.length > 0 ? <p>{Message}</p> : null}

            <button className="invia_contatti" type="button" onClick={() => sendFormHandler()}>
              Invia
            </button>
          </div>
        </div>
      </div>
      <ContactsSnippet 
        cfg={props.cfg}
      />
    </>
  );
};

export default ContactPage;